import React from 'react';
export var NotificationContext = React.createContext(undefined);
